import {useFormContext} from '@yandex-delivery/nlf-form/v2'

import {mapVerticalToDeliveryType} from 'src/shared/utils'

export function useVerticalType() {
  const {watch} = useFormContext()
  const verticalName = watch('offerFlow.vertical.name')

  return {
    rawVertical: verticalName,
    mappedVertical: mapVerticalToDeliveryType(verticalName),
  }
}
